module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('editor', {
    attrs: {
      "structure": _vm.orderedUnpublishedStructure,
      "dragElements": _vm.dragElements,
      "showTabs": true,
      "limitEditing": false,
      "shouldIncludeSubmit": false,
      "editorName": 'LeadMask'
    },
    on: {
      "save": _vm.save,
      "publish": _vm.publish
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-447c71be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/lead_masks/LeadMaskEditor.vue
// module id = 1885
// module chunks = 0